export const sessionStorageJsonItem = <T>(key: string) => {
  const setSessionData = (data: T): void => {
    try {
      sessionStorage.setItem(key, JSON.stringify(data))
    } catch {}
  }

  const getSessionData = (): T | null => {
    if (typeof sessionStorage === 'undefined') {
      return null
    }

    try {
      const sessionData = sessionStorage.getItem(key)
      const parsed = JSON.parse(sessionData)
      return parsed
    } catch {
      return null
    }
  }

  const clearSessionData = (): void => {
    try {
      sessionStorage.removeItem(key)
    } catch {}
  }

  return { setSessionData, getSessionData, clearSessionData }
}
